<div class="line-list-table table-wrapper" [hidden]="!dataSource?.data?.length">
  <table mat-table class="full-width-table spc-table" matSort aria-label="Elements">
    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef id="slno">{{'common.table_slno' | translate}}.</th>
      <td mat-cell class="ellipsis col1" *matCellDef="let row ; let i = index;">{{i+1}}</td>
    </ng-container>
    <ng-container matColumnDef="parametername">
      <th mat-header-cell *matHeaderCellDef mat-sort-header id="parametername">Parameter Name</th>
      <td mat-cell class="ellipsis col-area" [matTooltip]="row.parametername" *matCellDef="let row">
        {{row.parametername}}
      </td>
    </ng-container>
    <ng-container matColumnDef="lsl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header id="factoryn">LSL
      </th>
      <td mat-cell class="ellipsis col2" [matTooltip]="row.lsl" *matCellDef="let row">
        {{row.lsl?.toFixed(2)}}
      </td>
    </ng-container>
    <ng-container matColumnDef="targetvalue">
      <th mat-header-cell *matHeaderCellDef mat-sort-header id="targetvalue">{{'spc.configurator.parameter.target'
      | translate}}</th>
      <td mat-cell class="ellipsis col3" [matTooltip]="row.targetvalue" *matCellDef="let row">
      {{row.targetvalue?.toFixed(2)}}</td>
    </ng-container>
    <ng-container matColumnDef="usl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header id="usl">USL</th>
      <td mat-cell class="ellipsis col4" [matTooltip]="row.usl" *matCellDef="let row">
      {{row.usl?.toFixed(2)}}</td>
    </ng-container>
    @if (type === 'process') {
      <ng-container matColumnDef="mean">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="mean">Mean</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.mean" *matCellDef="let row">
        {{row.mean?.toFixed(2)}}</td>
      </ng-container>
      <ng-container matColumnDef="stddev">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="stddev">Std Dev</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.stddev" *matCellDef="let row">
        {{row.stddev?.toFixed(2)}}</td>
      </ng-container>
      <ng-container matColumnDef="pp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="usl">Pp</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.pp" *matCellDef="let row">
          @if (row?.kpi?.sigmaval !== 0 && !(row?.kpi?.xcp > 50)) {
            <span> {{row.pp?.toFixed(2)}}</span>
          }
          @if ((row?.stddev === 0 || row?.kpi?.xcp > 50 || row?.kpi?.xcp === null) && row?.timeSeriesData) {
            <span class="cp-infinity"
              >
              <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="ppk">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="usl">Ppk</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.ppk" *matCellDef="let row">
          @if (row?.kpi?.sigmaval !== 0 && !(row?.kpi?.xcpk > 50)) {
            <span> {{row.ppk?.toFixed(2)}}</span>
          }
          @if ((row?.stddev === 0 || row?.kpi?.xcp > 50 || row?.kpi?.xcpk === null) && row?.timeSeriesData) {
            <span class="cp-infinity"
              >
              <img class="infinite-symbol" alt="infinite" src="assets/images/infinity.svg">
            </span>
          }
        </td>
      </ng-container>
    }
    @if (type === 'ga') {
      <ng-container matColumnDef="totalDataPoints">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="totalDataPoints">points</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.totalDataPoints" *matCellDef="let row">
        {{row.totalDataPoints}}</td>
      </ng-container>
      <ng-container matColumnDef="targetPacked">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="stddev">{{'ega.charts.target_volume' |
        translate}}(UOM)</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.targetPacked" *matCellDef="let row">
        {{row.targetPacked?.toFixed(0)}}</td>
      </ng-container>
      <ng-container matColumnDef="actualPacked">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="actualPacked">{{'ega.charts.actual_packed' |
        translate}}(UOM)</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.actualPacked" *matCellDef="let row">
        {{row.actualPacked?.toFixed(0)}}</td>
      </ng-container>
      <ng-container matColumnDef="giveAway">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="giveAway">Excess GA</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.giveAway" *matCellDef="let row">
        {{row.giveAway?.toFixed(0)}}</td>
      </ng-container>
      <ng-container matColumnDef="giveAwayPercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="giveAwayPercentage">Excess GA %</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.giveAwayPercentage" *matCellDef="let row">
        {{formatMetric(row.giveAwayPercentage, 1)}}</td>
      </ng-container>
      <ng-container matColumnDef="lslRejectPercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="lslRejectPercentage">LSL Reject %</th>
        <td mat-cell class="ellipsis col4" [matTooltip]="row.lslRejectPercentage" *matCellDef="let row">
        {{formatMetric(row.lslRejectPercentage, 3)}}</td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
</div>